import { Form } from '@sitecore-jss/sitecore-jss-react-forms';
import { FormProps } from '@sitecore-jss/sitecore-jss-react-forms/types/components/form';

export interface FormComponentProps extends FormProps {
  onFieldChangeCallback?: (key: string, value: string | string[] | File[]) => void;
}

export class FormComponent extends Form {
  declare props: FormComponentProps;

  constructor(props: FormComponentProps) {
    super(props);

    const originalOnFieldChange = this.onFieldChange.bind(this);

    this.onFieldChange = (
      key: string,
      value: string | string[] | File[],
      isValid: boolean,
      errors: string[]
    ) => {
      originalOnFieldChange(key, value, isValid, errors);

      if (this.props.onFieldChangeCallback) {
        this.props.onFieldChangeCallback(key, value);
      }
    };
  }
}
